import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPermission, IPermissionAssignByRole, IPermissionByRoleAssign } from '../interfaces/i-permission';
import { Structures } from '@clavisco/core';
import ICLResponse = Structures.Interfaces.ICLResponse;

/**
 * PermissionService provides methods for managing permissions.
 * It includes functionality to retrieve and assign permissions by role.
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  /**
   * Constructs the PermissionService.
   *
   * @param {HttpClient} http - The Angular HTTP client used for making HTTP requests.
   */
  constructor(
    private http: HttpClient
  ) { }

  /**
   * Retrieves the permissions assigned to a role based on the provided role ID.
   *
   * @param {number} roleId - The ID of the role for which to fetch permissions.
   * @returns {Observable<ICLResponse<IPermission[]>>} An observable containing the response with the list of permissions for the role.
   */
  GetPermissionsByRole(roleId: number): Observable<ICLResponse<IPermission[]>> {
    return this.http.get<ICLResponse<IPermission[]>>(`api/Permissions/GetPermissionsByRol?roleId=${roleId}`);
  }

  /**
   * Assigns permissions to a role by sending a POST request to the API.
   *
   * @param {IPermissionAssignByRole} data - The data containing permissions to assign to the role.
   * @returns {Observable<any>} An observable containing the response from the API.
   */
  PostPermissionsByRole(data: IPermissionAssignByRole): Observable<any> {
    return this.http.post(`api/Permissions/PostPermissionsByRol`, data);
  }

  /**
   * Retrieves the permissions assigned to a role in a detailed format based on the provided role ID.
   *
   * @param {number} rolId - The ID of the role for which to fetch detailed permissions.
   * @returns {Observable<ICLResponse<IPermissionByRoleAssign[]>>} An observable containing the response with the detailed list of permissions for the role.
   */
  GetPermissionsByRoleAssing(rolId: number): Observable<ICLResponse<IPermissionByRoleAssign[]>> {
    return this.http.get<ICLResponse<IPermissionByRoleAssign[]>>(`api/Permissions/GetPermissionsByRolAssign?roleId=${rolId}`);
  }

}
